import styled from 'styled-components'

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  cursor: pointer;

  background: var(--color-neutral-100);
  border: 1px solid var(--color-primary-200);
  border-radius: var(--size-border-radius-small);
`
